module.exports = new __parcel__URL__("crossIconWhite.b2346fef.svg").toString();